import { ExerciseQuestionInput, ResourceResponseTypeEnum } from '@/types/schema';

export const INPUT_CHARACTER_LIMIT = 500;

export const INPUT_ROW_LIMIT = 5;

export const DEFAULT_QUESTION_ITEM: ExerciseQuestionInput = {
  text: '',
  responseType: ResourceResponseTypeEnum.Any,
};
